import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { selectViewIsDirty, setViewIsDirty } from "@features/ux/uxSlice";


// core components
import Wizard from "components/Wizard/Wizard.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Step1 from "./Step1.js";
import Step2 from "./Step2.js";
import Step3 from "./Step3.js";
import Step4 from "./Step4.js";
import { useCreateClientMutation } from "api/client.api";

export default function ProvisionClient() {
  const dispatch = useDispatch();
  const viewIsDirty = useSelector(selectViewIsDirty);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [createNewClient] = useCreateClientMutation();
  const history = useHistory();

  const finishedHandler = (payload) => {
    createNewClient(payload).unwrap();
    dispatch(setViewIsDirty(false));
    setShouldRedirect(true);
  }

  useEffect(() => {
    if (shouldRedirect && !viewIsDirty) {
      history.push('/admin/companies');
    }
    if(!shouldRedirect){
      dispatch(setViewIsDirty(true));
    }
  }, [shouldRedirect, viewIsDirty]);

  return (
    <GridContainer justify="center">
      <GridItem xs={12} sm={8}>
        <Wizard
          validate
          steps={[
            { stepName: "Company", stepComponent: Step1, stepId: "company" },
            { stepName: "Billing Contact", stepComponent: Step2, stepId: "billing" },
            { stepName: "Administrator", stepComponent: Step3, stepId: "administrator" },
            { stepName: "Environments", stepComponent: Step4, stepId: "environments" }
          ]}
          title="Provision New Company"
          subtitle="Setup new company for InStore Center"
          finishButtonClick={payload => finishedHandler(payload)}
        />
      </GridItem>
    </GridContainer>
  );
}
